export const DETAILS_LAST_READING_REQUEST = "DETAILS_LAST_READING_REQUEST";
export const DETAILS_LAST_READING_RESULT = "DETAILS_LAST_READING_RESULT";